import React,{useState,useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import VerticalNavBar from '../../../components/Navbar/PlatformNavBar/VerticalNavBar'
import { ContentCard } from '../../../components/MujerSoberana/ContentCard';
import { SubscriptionModal } from '../../../components/MujerSoberana/SubscriptionModal';
import {Pagination,Stack} from '@mui/material';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination as SwiperPagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./VideoLibraryPro.css";
import { Link } from 'react-router-dom';
import {
  getAllVideos,
  getAllVideosByPage,
  getVideoBySerieId,
  getVideosByTag,
  getVideosByDuration,
  getVideosByLevel,
  getVideosByBetweenDuration,
} from "../../../services/videos";
import { getSeriesById } from '../../../services/series';
import { getAllMandalas } from '../../../services/mandalas';
import {useNavigate } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import { checkUserMembership,checkAllowUser } from '../../../utils/checkSubscription';

const getNormalizedAllowedSubscriptions = (video) => {
  const rawAllowed = video?.allowedSubscriptions ?? video?.allowedSubscription ?? [];
  const list = Array.isArray(rawAllowed) ? rawAllowed : [rawAllowed];

  return list
    .map((value) => String(value || '').trim().toUpperCase())
    .filter(Boolean);
};


const VideoLibray = () => {

    const [videosList, setVideosList] = useState([]);
    const [serieInfo,setSerieInfo] = useState();
    const [filterVideosList, setFilterVideosList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingCheck, setIsLoadingCheck] = useState(true);
    const [currentUser,setCurrentUser] = useState(useSelector((state) => state.user.currentUser));
    const [allowUserList, setAllowUserList] = useState([]);
    const [subcriptionUserList, setSubscriptionUserList] = useState([]);
    const [isSubscriptionOpen, setIsSubscriptionOpen] = useState(false);
    const [viewMode, setViewMode] = useState('v3');
    const [savedCards, setSavedCards] = useState(new Set());
    const [mandalasList, setMandalasList] = useState([]);
    const [isLoadingMandalas, setIsLoadingMandalas] = useState(true);
    const [selectedMandala, setSelectedMandala] = useState(null);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const paramNames = Array.from(urlParams.keys());
    const param = paramNames[0];
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(16);
    const [totalPages, setTotalPages] = useState(0);
    const history = useNavigate();
    const dispatch = useDispatch();

    const getAllVideosList =  async () => {
      try{     
          setIsLoading(true);
          setVideosList([]);
          setFilterVideosList([]);
          const response = await getAllVideosByPage(page,pageSize);
          const responseData = response.data;
          setTotalPages(responseData.totalPages)
          if (responseData && responseData.content && responseData.content.length > 0) {
              const newVideosList = responseData.content;
              setVideosList(prevVideosList => [...prevVideosList, ...newVideosList]);
              setFilterVideosList(prevFilterVideosList => [...prevFilterVideosList, ...newVideosList]);
          } else {
              console.log('No videos found.');
          }
      }catch(error){
          console.log(error);
      }finally{
          setIsLoading(false);
      }
    };

    useEffect(() => {
      handleMandalasList();
    }, []);

    useEffect(() => {
      if (param === 'all') {
        getAllVideosList();
    }
    }, [page]);

    const handlePageChange = (event, value) => {
      setPage(value - 1);
    };

    const getVideosListBySerie = async (serieId) => {
      try {
        setIsLoading(true);
        
        const response = await getVideoBySerieId(serieId);
        const data = response.data;
        setVideosList(data);
        setFilterVideosList(data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    const getVideosListByTag = async (tag) => {
        try {
          setIsLoading(true);
          const response = await getVideosByTag(tag);
          const data = response.data;
          setVideosList(data);
          setFilterVideosList(data);
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      };


    const getVideosListByIntensity = async (level) => {
      try {
        setIsLoading(true);
        const response = await getVideosByLevel(level);
        const data = response.data;
        setVideosList(data);
        setFilterVideosList(data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };     

    const getVideosListByDuration = async (tag) => {
      try {
        setIsLoading(true);
        const response = await getVideosByDuration(tag);
        const data = response.data;
        setVideosList(data);
        setFilterVideosList(data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    const getVideosListByRange = async () => {
      try {
        const paramNames = Array.from(urlParams.keys());
        const minDuration = urlParams.get(paramNames[0]);
        const maxDuration = urlParams.get(paramNames[1]);
        setIsLoading(true);
        const response = await getVideosByBetweenDuration(
        parseInt(minDuration),
          parseInt(maxDuration)
        );
        const data = response.data;
        setVideosList(data);
        setFilterVideosList(data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };  
     
    const getVideoList=(param,value) =>{
        switch (param) {
          case "all":
            break;
          case "series":
            getVideosListBySerie(value);
            break;
          case "tag":
            getVideosListByTag(value);
            break;
          case "duration":
            getVideosListByDuration(value);
            break;
          case "range":
            getVideosListByRange();
            break;
          case "intensity":
            getVideosListByIntensity(value);
            break;
          default:
            getAllVideosList();
            break;
        }
    }

    const getSeriesDetails = async(seriesId) => {
      try {
        setIsLoading(true);
        const res = await getSeriesById(seriesId);
        console.log(res);
        if(res && res.status === 404){
          setSerieInfo(null);
        }else{
          setSerieInfo(res.data);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }

    const handleSearch=(option) =>{
      if(option.length!==0){
        setFilterVideosList(option);
      }else{
        setFilterVideosList(videosList);
      };      
    }

  
    const checkSubscription= async()=>{
      try {
        setIsLoading(true);
        return checkUserMembership(currentUser)
      } catch (error) {
        console.error(error);
      }finally{
        setIsLoading(false);
      }
  
    }

    const handleGoBack = () => {
      history(-1);
    };

    // Fetch mandalas
    const handleMandalasList = async() => {
      try {
        setIsLoadingMandalas(true);
        const res = await getAllMandalas();
        setMandalasList(res.data);
      } catch (error) {
        console.error('Error fetching mandalas:', error);
      } finally {
        setIsLoadingMandalas(false);
      }
    };

    // Handle mandala filter click
    const handleMandalaClick = async(mandala) => {
      setSelectedMandala(mandala.serieId);
      // Filter videos by the selected mandala/series
      await getVideosListBySerie(mandala.serieId);
    };

    // 

    // Transform video data to ContentCard format
    const transformToContentCard = (video, index) => {
      const normalizedAllowedSubscriptions = getNormalizedAllowedSubscriptions(video);
      const hasFreeAccess = normalizedAllowedSubscriptions.includes('FREE');
      const isAllowed = currentUser.email === 'sara.asanas@gmail.com' ? true : hasFreeAccess || allowUserList[index];
      return {
        id: video.videoId,
        title: video.title,
        description: video.description || 'Practica de yoga transformadora',
        category: video.tags?.[0] || 'Yoga',
        level: mapIntensityLevel(video.intensityLevel),
        format: 'video',
        duration: `${video.duration} min`,
        thumbnail: video.thumbnail,
        instructor: { name: 'Sara Asanas', initials: 'SA' },
        isPremium: !isAllowed,
        isSaved: savedCards.has(video.videoId),
      };
    };

    const mapIntensityLevel = (level) => {
      const levelMap = {
        'Restaurativo': 'restorative',
        'Suave': 'gentle',
        'Intermedio': 'moderate',
        'Avanzado': 'dynamic',
      };
      return levelMap[level] || 'moderate';
    };

    const handleCardClick = (card) => {
      // If content is premium and user doesn't have subscription, open subscription modal
      if (card.isPremium) {
        setIsSubscriptionOpen(true);
      } else {
        // Navigate to video player - using the correct route format
        history(`/video/${card.id}`);
      }
    };

    const handleSaveCard = (cardId) => {
      setSavedCards((prev) => {
        const newSet = new Set(prev);
        if (newSet.has(cardId)) {
          newSet.delete(cardId);
        } else {
          newSet.add(cardId);
        }
        return newSet;
      });
    };

    const handleSubscribe = async (planId) => {
      console.log('Subscribe to:', planId);
      // Navigate to subscription page or handle payment
      history('/platform/subscription');
    };

    const handleViewChange = (newView) => {
      setViewMode(newView);
    };

    // Grid layout classes
    const getGridClass = () => {
      const baseClass = 'grid gap-6 mb-12';
      switch (viewMode) {
        case 'v2': // Fetch mandalas on mount
          return `${baseClass} grid-cols-1 md:grid-cols-2`;
        case 'v4':
          return `${baseClass} grid-cols-2 md:grid-cols-3 lg:grid-cols-4`;
        case 'vlist':
          return `${baseClass} grid-cols-1`;
        default: // v3
          return `${baseClass} grid-cols-1 md:grid-cols-2 lg:grid-cols-3`;
      }
    };


     useEffect(() =>{
      const paramNames = Array.from(urlParams.keys());
      const param = paramNames[0];
      const value = urlParams.get(paramNames[0]);
      getSeriesDetails(value);
      getVideoList(param,value);
      checkSubscription()
      .then(subscriptionResult => {
        setSubscriptionUserList(subscriptionResult);
      })
      .catch(error => {
        console.error("Error while fetching subscription:", error);
      });
    },[])
    
    useEffect(() => {
      const fetchData = async () => {    
        try {
          if (!videosList) {
            throw new Error('Videos list is not available');
          }
    
          const updatedAllowUserList = videosList.map((item) => {
            return checkAllowUser(item, currentUser, subcriptionUserList);
          });
    
          setAllowUserList(updatedAllowUserList);
        } catch (error) {
          console.error(error);
        } finally {
          setIsLoadingCheck(false);
        }
      };
    
      fetchData();
    }, [videosList, currentUser,subcriptionUserList]);



      return (
        <>
          <section className="index-platform flex gap-3">
            <VerticalNavBar />
            <div className="video-library-container flex flex-col justify-start items-center pb-5 sm:px-8 md:px-12 w-full">
              <div className=" flex flex-col justify-center items-center pb-10">
                <div className="image-container w-12 h-20">
                  <img
                    src="../../assets/icons/Logo/Logo-sm.png"
                    alt="Logo-SA"
                  />
                </div>
                <div className="text text-center">
                  <p className="font-[Generica]">
                    "It's not about being good at something. It's about being
                    good to yourself."
                  </p>
                </div>
              </div>

              {/* Mandala Filter Carousel - Only show on 'all' page */}
              {param === 'all' && (
                <div className="w-full max-w-[min(90vw,1400px)] mb-6 filter-by-mandala-box">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                      <div className="w-5 h-px bg-gray-300" />
                      <h3 className="text-xs font-semibold tracking-widest text-gray-600 uppercase">
                        Filtrar por Mandala
                      </h3>
                    </div>
                    {selectedMandala && (
                      <button
                        onClick={() => {
                          setSelectedMandala(null);
                          getAllVideosList();
                        }}
                        className="text-xs font-semibold text-sb-600 uppercase tracking-widest hover:border-b border-sb-600 transition-colors"
                      >
                        Ver Todos →
                      </button>
                    )}
                  </div>
                  
                  {/* Loading State */}
                  {isLoadingMandalas ? (
                    <div className="flex justify-center items-center gap-4 py-8">
                      {[...Array(5)].map((_, i) => (
                        <div key={i} className="flex flex-col items-center gap-2">
                          <div className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-gray-200 animate-pulse" />
                          <div className="h-4 w-20 bg-gray-200 rounded animate-pulse" />
                          <div className="h-3 w-16 bg-gray-200 rounded animate-pulse" />
                        </div>
                      ))}
                    </div>
                  ) : mandalasList.length > 0 ? (
                  
                  <Swiper
                    modules={[Navigation, SwiperPagination]}
                    spaceBetween={10}
                    slidesPerView={2}
                    centeredSlides={true}
                    pagination
                    initialSlide={0}
                    breakpoints={{
                      600: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                        centeredSlides: false,
                      },
                      768: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                        centeredSlides: false,
                      },
                      1024: {
                        slidesPerView: 5,
                        spaceBetween: 30,
                        centeredSlides: false,
                      },
                    }}
                    className="mySwiper w-full h-[280px]"
                  >
                    {mandalasList.map((item, index) => (
                      <SwiperSlide 
                        className="mantra-box flex flex-col justify-center items-center text-center gap-1" 
                        key={index}
                      >
                        {item.active ? (
                          <div 
                            onClick={() => handleMandalaClick(item)}
                            className="cursor-pointer w-full flex flex-col items-center"
                          >
                            <div className={`image-container ${selectedMandala === item.serieId ? 'ring-4 ring-so-600' : ''}`}>
                              <img src={item.path} alt={item.name} />
                            </div>
                          </div>
                        ) : (
                          <div className="image-container next">
                            <img src={item.path} alt={item.name} />
                            <p className="next-label">Próximamente</p>
                          </div>
                        )}
                        <p className='uppercase font-[MADE-Bon-Voyage] text-xl'>{item.name}</p>
                        <p className='uppercase font-[MADE-Bon-Voyage] text-lg'>{item.month}</p>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  ) : (
                    <p className="text-center text-gray-500 py-8">No mandalas disponibles</p>
                  )}
                </div>
              )}

              {/* Search Bar */}
              <Stack spacing={3} sx={{ width: "clamp(300px, 90%, 1400px)", padding: "1.75rem 0" }}>
                {isLoading ? null : (
                  <Autocomplete
                    className="border-[1px] rounded-full w-full px-5 py-2 flex justify-center items-center"
                    multiple
                    id="size-small-outlined-multi"
                    options={videosList}
                    getOptionLabel={(option) => option.title}
                    onChange={(event, newValue) => handleSearch(newValue)}
                    renderInput={(params) => (
                      <>
                        <SearchIcon />
                        <TextField
                          {...params}
                          variant="standard"
                          placeholder="Busqueda"
                        />
                      </>
                    )}
                  />
                )}
              </Stack>

              {/* View Mode Controls */}
              <div className="flex items-center justify-between w-full max-w-[min(90%,1400px)] mb-4 py-2.5 px-3.5 rounded-xl border border-so-100" style={{ background: 'rgba(234,229,200,0.45)' }}>
                <div className="flex items-center gap-4">
                  <span className="text-sm text-gray-600">
                    Mostrando <strong>{filterVideosList.length}</strong> videos
                  </span>
                </div>

                {/* View Toggle */}
                <div className="flex items-center gap-1">
                  {['v2', 'v3', 'v4', 'vlist'].map((view) => (
                    <button
                      key={view}
                      onClick={() => handleViewChange(view)}
                      className={`w-8 h-8 md:w-9 md:h-9 rounded-xl flex items-center justify-center transition-all touch-action-manipulation ${
                        viewMode === view
                          ? 'bg-so-600 text-white shadow-lg'
                          : 'text-gray-400 hover:bg-sb-100 hover:text-sb-600 active:bg-so-600 active:text-white'
                      } ${
                        (view === 'v4' || view === 'vlist') ? 'hidden md:flex' : ''
                      }`}
                      title={`View: ${view}`}
                      aria-label={`View mode: ${view}`}
                    >
                      {view === 'v2' && (
                        <svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor">
                          <rect x="1" y="1" width="6.5" height="6.5" rx="1.5" />
                          <rect x="8.5" y="1" width="6.5" height="6.5" rx="1.5" />
                          <rect x="1" y="8.5" width="6.5" height="6.5" rx="1.5" />
                          <rect x="8.5" y="8.5" width="6.5" height="6.5" rx="1.5" />
                        </svg>
                      )}
                      {view === 'v3' && (
                        <svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor">
                          <rect x="1" y="1" width="4" height="6" rx="1" />
                          <rect x="6" y="1" width="4" height="6" rx="1" />
                          <rect x="11" y="1" width="4" height="6" rx="1" />
                          <rect x="1" y="9" width="4" height="6" rx="1" />
                          <rect x="6" y="9" width="4" height="6" rx="1" />
                          <rect x="11" y="9" width="4" height="6" rx="1" />
                        </svg>
                      )}
                      {view === 'v4' && (
                        <svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor">
                          <rect x="1" y="1" width="2.8" height="5" rx="0.7" />
                          <rect x="4.7" y="1" width="2.8" height="5" rx="0.7" />
                          <rect x="8.4" y="1" width="2.8" height="5" rx="0.7" />
                          <rect x="12.1" y="1" width="2.8" height="5" rx="0.7" />
                          <rect x="1" y="8" width="2.8" height="5" rx="0.7" />
                          <rect x="4.7" y="8" width="2.8" height="5" rx="0.7" />
                          <rect x="8.4" y="8" width="2.8" height="5" rx="0.7" />
                          <rect x="12.1" y="8" width="2.8" height="5" rx="0.7" />
                        </svg>
                      )}
                      {view === 'vlist' && (
                        <svg width="15" height="15" viewBox="0 0 16 16" fill="currentColor">
                          <rect x="1" y="1.5" width="14" height="3.5" rx="1" />
                          <rect x="1" y="6.3" width="14" height="3.5" rx="1" />
                          <rect x="1" y="11" width="14" height="3.5" rx="1" />
                        </svg>
                      )}
                    </button>
                  ))}
                </div>
              </div>

              {/* Video Grid */}
              <div className={`w-full max-w-[min(90%,1400px)] ${getGridClass()}`}>
                {isLoadingCheck ? (
                  // Loading skeleton
                  <>
                    {[...Array(8)].map((e, i) => (
                      <div key={i} className="rounded-2xl overflow-hidden bg-white shadow-lg animate-pulse">
                        <div className="aspect-video bg-gray-200" />
                        <div className="p-5 space-y-3">
                          <div className="h-4 bg-gray-200 rounded w-3/4" />
                          <div className="h-3 bg-gray-200 rounded w-full" />
                          <div className="h-3 bg-gray-200 rounded w-5/6" />
                        </div>
                      </div>
                    ))}
                  </>
                ) : !allowUserList.length || !filterVideosList.length ? (
                  // No videos available message
                  <div className="col-span-full flex flex-col justify-center items-center gap-5 py-12">
                    <div className="image-container flex flex-col justify center w-24">
                      <img src="../assets/icons/Forms/no-video.gif" alt="not-video" />
                    </div>
                    <h4 className="text-xl text-sb-800 opacity-50 uppercase font-[DIN-Condensed]">
                      No hay videos disponibles
                    </h4>
                  </div>
                ) : (
                  // Render videos with ContentCard
                  filterVideosList.map((item, index) => (
                    <ContentCard
                      key={item.videoId}
                      card={transformToContentCard(item, index)}
                      viewMode={viewMode}
                      onCardClick={handleCardClick}
                      onSave={handleSaveCard}
                    />
                  ))
                )}
              </div>

              {/* Pagination */}
              {param ==='all' && (
                <Stack spacing={2} justifyContent="center" alignItems="center" mt={2}>
                  <Pagination
                      count={totalPages}
                      page={page + 1}
                      onChange={handlePageChange}
                      color="primary"
                  />
              </Stack>
              )}

            </div>
          </section>

          {/* Subscription Modal */}
          <SubscriptionModal
            isOpen={isSubscriptionOpen}
            onClose={() => setIsSubscriptionOpen(false)}
            onSubscribe={handleSubscribe}
          />
        </>
      );
}

export default VideoLibray
